const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="203" height="231" viewBox="0 0 203 231" fill="none">
        <path d="M194.758 5.2002L192.016 12.0576L170.627 65.5273L192.016 118.999L194.758 125.855H37.4556V225.445H5.32471V5.2002H194.758Z" fill="#2D2926" stroke="white" stroke-width="10"/>
    </svg>
`

export const startPointMarker = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
